import { mapFileFields, mapImageFields } from '@/adapters/common'
import { ICountry, IInstitution } from '@/interfaces/institutions'

export function mapCountryFields(item: Directus.Country): ICountry {
  return {
    id: item.id,
    image: mapImageFields(item.image),
    ...item.translations[0],
  }
}

export function mapInstitutionFields(item: Directus.Institution, locale?: string): IInstitution {
  return {
    id: item.id,
    url: item.url,
    country: item.country ? mapCountryFields(item.country) : null,
    logo: locale === 'ru-RU' && item.logo_ru ? mapFileFields(item.logo_ru) : mapFileFields(item.logo),
    logo_black:
      locale === 'ru-RU' && item.logo_black_ru ? mapFileFields(item.logo_black_ru) : mapFileFields(item.logo_black),
    ...item.translations[0],
  }
}
